import request from "graphql-request";
import BASEURL from "../../pages/Utils/Baseurl";
import { deleteContact, updateContact } from "../graphQL/graphMutation";

export const updateContactService = async (values, id) => {
  let updateStatus = false;
  let errormessage;
  try {
    const res = await request(BASEURL, updateContact, {
      input:{
        id:id,
        ...values,
      }
     
    });
    updateStatus = true;
  } catch (err) {
    console.error(err.message, "updateAppointmentService error");
    errormessage=err.response.errors?.[0].message;
    updateStatus = false;
  }

  return {updateStatus,errormessage};
};

export const deleteContactService = async (id) => {
  let delteStatus = false;
  try {
    const res = await request(BASEURL, deleteContact, { id: id });
    delteStatus = true;
  } catch (err) {
    console.error(err.message, "deleteAppointmentService error");
    delteStatus = false;
  }
  return delteStatus;
};
